<template>
  <div>
    <!-- 选择项目名称弹窗 -->
    <van-dialog v-model="visible" title="项目名称" width="95%" style="height:50%" class="editClue" :beforeClose="saveProjectName" :close-on-click-overlay="true" show-cancel-button>
      <van-form ref="projectForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-field readonly clickable v-model="projectForm.businessTypeName" @click="showCascader('businessType')" label="业务类型" :rules="[{ required: true }]" placeholder="请选择业务类型" required />
        <van-field readonly clickable v-model="projectForm.industryName" @click="projectForm.businessTypeName?showCascader('industry'):''" label="行业分类" :rules="[{ required: true }]" placeholder="请选择行业分类/请先选择业务类型" required v-if="projectForm.businessTypeName?projectForm.businessTypeName.indexOf('品牌推广类') === -1 && projectForm.businessTypeName.indexOf('数字技术类') === -1:false" />
        <van-field readonly clickable v-model="projectForm.mediaLocationName" @click="projectForm.businessTypeName?showPicker('mediaLocation'):''" label="媒体产品" :rules="[{ required: true }]" placeholder="请先选择业务类型后选择媒体产品" required />
        <van-field readonly clickable v-model="projectForm.operationModeName" @click="showPicker('operationMode')" label="运营方式" :rules="[{ required: true }]" placeholder="请选择运营方式" required />
        <van-cell title="计算方式" required>
          <template>
            <van-radio-group v-model="projectForm.calculationMethod" direction="horizontal">
              <van-radio :name="1" clickable>返货</van-radio>
              <van-radio :name="2" clickable>返现</van-radio>
            </van-radio-group>
          </template>
        </van-cell>
        <van-button type="info" block size="small" style="width: 70%;margin: 0 auto;" native-type="button" @click="imageShow = true">查看【账户币-现金金额】换算公式</van-button>
      </van-form>
    </van-dialog>

    <van-image-preview v-model="imageShow" :images="imageArr"></van-image-preview>

    <van-popup v-model="picker.visible" position="bottom">
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <van-popup v-model="cascader.visible" position="bottom">
      <van-cascader :title="cascader.title" :options="cascader.treeList" :field-names="cascader.fieldNames" @change="serviceChange" @close="cascader.visible = false" @finish="onFinishTree" />
    </van-popup>
  </div>
</template>

<script>
import { selectAllAddBo, listAllBusinessTypeMedia, advIndustryPointList } from '@/api/admi/dept'
import newContract from '@/api/cont/newContract'
import { Toast, Cascader, ImagePreview } from 'vant'
export default {
  components: {
    [Toast.name]: Toast,
    vanCascader: Cascader,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  props: {
    contractId: [Number, String],
    projectId: [Number, String],
    selectProjectVisible: Boolean,
    isFirst: Boolean
  },
  watch: {
    contractId: {
      immediate: true,
      handler(val, oldVal) {

      }
    },
    selectProjectVisible: {
      immediate: true,
      async handler(val, oldVal) {
        this.visible = val
        if (val) {
          if (this.projectId) {
            await newContract.getProject(this.projectId).then(res => {
              if (res.code == 200) {
                this.projectForm = res.data
                this.projectForm.businessTypeId = res.data.businessTypeId
                this.projectForm.businessTypeName = res.data.projectName.split(' ')[0]
              }
            })
            await listAllBusinessTypeMedia({ businessTypeId: this.projectForm.businessTypeId }).then(response => {
              if (response.code == 200) {
                this.mediaOptions = response.data
              }
            })
            this.projectForm.mediaLocationName = this.mediaOptions.find(item => { return item.businessTypeMediaId === this.projectForm.mediaId }).mediaName
            this.projectForm.operationModeName = this.options.operationModeOptions.find(item => { return item.dictValue == this.projectForm.operationMode }).dictLabel
            this.$set(this.projectForm)
          } else {
            this.projectForm = { businessTypeName: null, calculationMethod: 1 }
          }
        }
      }
    },
    isFirst: {
      immediate: true,
      handler(val, oldVal) {
        if (val && !this.projectId) {
          newContract.getContract(this.contractId).then(res => {
            if (res.code == 200) {
              this.projectForm.businessTypeName = res.data.businessTypeName
              listAllBusinessTypeMedia({ businessTypeId: res.data.businessTypeId }).then(response => {
                if (response.code == 200) {
                  this.mediaOptions = response.data
                }
              })
            }
          })
        }
      }
    }
  },
  data() {
    return {
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      cascader: {
        visible: false,
        type: '',
        title: '',
        treeList: [],
        fieldNames: {

        }
      },
      serviceTypeTreeList: [],
      options: {
        mediaLocationOptions: [],
        operationModeOptions: []
      },
      // 选择项目名称
      businessTypeName: null,
      mediaLocationList: [], // 媒体版位列表
      mediaOptions: [], // 媒体产品列表
      operationModeOptions: this.$store.state.dictOptions.operationMode || [], // 运营方式
      businessTypeList: [], // 业务类型列表
      businessTypeOptions: [],
      industryList: [],
      visible: false,
      projectForm: {
        businessTypeName: null,
        advIndustryPointId: null,
        industryName: null,
        calculationMethod: 1
      },

      imageShow: false,
      imageArr: [require('../../../assets/images/desktop/formula.png')]
    }
  },
  async mounted() {
    // 运营方式
    await this.getDicts('operation_mode').then(res => {
      this.options.operationModeOptions = res.data
    })
  },
  methods: {
    async showCascader(type) {
      this.cascader.type = type
      if (type === 'businessType') {
        this.cascader.fieldNames = {
          text: 'businessTypeName',
          value: 'businessTypeId'
        }
        if (this.serviceTypeTreeList.length == 0) {
        // 获取获取业务类型
          await selectAllAddBo().then((response) => {
            if (response.code === 200) {
              this.serviceTypeTreeList = this.handleTree(response.data, 'businessTypeId')
            }
          })
        }
        this.cascader.treeList = this.serviceTypeTreeList
      } else if (type === 'mediaLocation') {
        this.cascader.fieldNames = {
          text: 'deliveryLinkName',
          value: 'deliveryLinkId'
        }
        if (this.options.mediaLocationOptions.length == 0) {
          await newContract.getTreeData({ deliveryLink: 2 }).then(res => {
            this.options.mediaLocationOptions = this.handleTree(res.rows, 'deliveryLinkId')
          })
        }
        this.cascader.treeList = this.options.mediaLocationOptions
      } else if (type === 'industry') {
        this.cascader.fieldNames = {
          text: 'industryName',
          value: 'advIndustryPointId'
        }
        await advIndustryPointList({ businessTypeId: this.projectForm.businessTypeId, businessTypeName: this.projectForm.businessTypeName.split('/')[this.projectForm.businessTypeName.split('/').length - 1] }).then(res => {
          if (res.code == 200) {
            this.industryList = this.handleTree(res.rows, 'advIndustryPointId')
          }
        })
        this.cascader.treeList = this.industryList
      }

      this.cascader.visible = true
    },
    serviceChange(obj) {

    },
    async onFinishTree(obj) {
      if (this.cascader.type === 'businessType') {
        this.projectForm.businessTypeId = obj.value
        this.projectForm.businessTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
        this.projectForm.businessTypeName = '销售/' + this.projectForm.businessTypeName
        await listAllBusinessTypeMedia({ businessTypeId: obj.value }).then(res => {
          if (res.code == 200) {
            this.mediaOptions = res.data
          }
        })
        this.projectForm.mediaId = null
        this.projectForm.mediaLocationName = null
        this.projectForm.advIndustryPointId = null
        this.projectForm.industryName = null
      } else if (this.cascader.type === 'mediaLocation') {
        this.projectForm.mediaId = obj.value
        this.projectForm.mediaLocationName = obj.selectedOptions.map((option) => option.deliveryLinkName).join('/')
      } else if (this.cascader.type === 'industry') {
        this.projectForm.advIndustryPointId = obj.value
        this.projectForm.industryName = obj.selectedOptions.map((option) => option.industryName).join('/')
      }
      this.cascader.visible = false
    },
    showPicker(type) {
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'mediaLocation') {
        this.picker.columns = this.mediaOptions.map((ele) => ele.mediaName)
        // this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
      }
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      if (this.picker.formKey === 'mediaLocation') {
        this.projectForm[name] = this.mediaOptions[key].mediaName
        this.projectForm.mediaId = this.mediaOptions[key].businessTypeMediaId
      } else {
        this.projectForm[this.picker.formKey] = this.options[optionItem][key].dictValue
        this.projectForm[name] = this.options[optionItem][key].dictLabel
      }

      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    pickerChange() { },
    // saveProjectName() {
    //   this.$refs.projectForm.validate(valid => {
    //     if (valid) {
    //       if (this.index == 0) {
    //         this.projectForm.businessTypeName = this.businessTypeName
    //       }
    //       // this.executiveForm.pointList[this.index].projectName = `${this.projectForm.businessTypeName} | ${this.projectForm.mediaLocationName} | ${this.projectForm.operationModeName}`
    //       this.$emit('confirm', `${this.projectForm.businessTypeName} | ${this.projectForm.mediaLocationName} | ${this.projectForm.operationModeName}`, this.index)
    //       this.visible = false
    //     }
    //   })
    // },
    async saveProjectName(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.projectForm.validate()
          this.projectForm.projectName = `${this.projectForm.businessTypeName} | ${this.projectForm.mediaLocationName} | ${this.projectForm.operationModeName}`
          // this.executiveForm.pointList[this.index].projectName = `${this.projectForm.businessTypeName} | ${this.projectForm.mediaLocationName} | ${this.projectForm.operationModeName}`
          this.$emit('confirm', this.projectForm)
          this.visible = false
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.$emit('confirm', '')
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.editClue /deep/.van-dialog__content {
  height: 68%;
}
/deep/ .van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
</style>
